import { useTranslation } from 'react-i18next';

export default function KanbanShowcase() {
  const { t } = useTranslation();
  
  const metrics = [
    { icon: 'ri-team-fill', label: t('kanban.metrics.totalLeads'), value: '10', detail: '3 🔥 5 🌡️ 2 ❄️', color: 'purple' },
    { icon: 'ri-money-dollar-circle-fill', label: t('kanban.metrics.totalValue'), value: 'R$ 23.439', detail: 'Média: R$ 2.343,9', color: 'green' },
    { icon: 'ri-line-chart-fill', label: t('kanban.metrics.conversion'), value: '30.0%', detail: '3 de 10 leads', color: 'blue' },
    { icon: 'ri-focus-3-fill', label: t('kanban.metrics.priority'), value: '3', detail: '5 médio, 2 baixo', color: 'yellow' },
    { icon: 'ri-loader-4-fill', label: t('kanban.metrics.inProgress'), value: '7', detail: 'Leads ativos no pipeline', color: 'orange' },
    { icon: 'ri-trophy-fill', label: t('kanban.metrics.performance'), value: '🔥', detail: t('kanban.metrics.excellent'), color: 'red' }
  ];

  const columns = [
    {
      title: t('kanban.columns.preQualified'),
      icon: 'ri-robot-fill',
      stats: { leads: null, value: null },
      tags: ['🔥 1', '~ 1', '❄️ 1', '🤖 3 IA'],
      color: 'purple',
      leads: [
        {
          name: 'Gabriel Thomas',
          status: t('kanban.leads.qualifiedByAI'),
          score: '🔥 30%',
          progress: 30,
          monitoring: true
        },
        {
          name: 'Alice Torres',
          status: t('kanban.leads.qualifiedByAI'),
          score: '~ 65%',
          progress: 65,
          monitoring: true
        },
        {
          name: 'Marina Rossi',
          status: t('kanban.leads.qualifiedByAI'),
          score: '❄️ 90%',
          progress: 90,
          monitoring: true
        }
      ]
    },
    {
      title: t('kanban.columns.initialContact'),
      icon: 'ri-chat-3-fill',
      stats: { leads: '2 Leads', value: 'R$ 5489' },
      tags: null,
      color: 'blue',
      leads: [
        {
          name: 'Daniel Smith',
          status: t('kanban.leads.newLead'),
          value: 'R$ 4.990',
          conversations: 7,
          broadcasts: 3,
          remarketing: 1,
          automations: 3,
          temperature: t('kanban.leads.warm'),
          priority: t('kanban.leads.medium'),
          time: t('kanban.leads.today'),
          phone: '11999990003'
        },
        {
          name: 'Clara Franco',
          status: t('kanban.leads.warmLead'),
          value: 'R$ 499',
          conversations: 12,
          broadcasts: 7,
          remarketing: 1,
          automations: 5,
          temperature: t('kanban.leads.warm'),
          priority: t('kanban.leads.medium'),
          time: t('kanban.leads.today'),
          phone: '21999990004'
        }
      ]
    },
    {
      title: t('kanban.columns.negotiation'),
      icon: 'ri-shake-hands-fill',
      stats: { leads: '3 Leads', value: 'R$ 6570' },
      tags: null,
      color: 'yellow',
      leads: [
        {
          name: 'Sophia Lima',
          status: t('kanban.leads.awaitingResponse'),
          value: 'R$ 2.190',
          conversations: 12,
          broadcasts: 5,
          remarketing: 2,
          automations: 5,
          temperature: t('kanban.leads.warm'),
          priority: t('kanban.leads.medium'),
          time: t('kanban.leads.today'),
          phone: '31999990005'
        },
        {
          name: 'Julia Mendes',
          status: t('kanban.leads.coldLead'),
          value: 'R$ 1.990',
          conversations: 12,
          broadcasts: 1,
          remarketing: 0,
          automations: 1,
          temperature: t('kanban.leads.cold'),
          priority: t('kanban.leads.low'),
          time: t('kanban.leads.today'),
          phone: '41999990006'
        },
        {
          name: 'David Cruz',
          status: t('kanban.leads.leadInAnalysis'),
          value: 'R$ 2.390',
          conversations: 9,
          broadcasts: 7,
          remarketing: 2,
          automations: 1,
          temperature: t('kanban.leads.warm'),
          priority: t('kanban.leads.medium'),
          time: t('kanban.leads.today'),
          phone: '51999990010'
        }
      ]
    },
    {
      title: t('kanban.columns.closing'),
      icon: 'ri-checkbox-circle-fill',
      stats: { leads: '3 Leads', value: 'R$ 4580' },
      tags: null,
      color: 'green',
      leads: [
        {
          name: 'Chris Diaz',
          status: t('kanban.leads.leadResolved'),
          value: 'R$ 100',
          conversations: 10,
          broadcasts: 3,
          remarketing: 1,
          automations: 1,
          temperature: t('kanban.leads.hot'),
          priority: t('kanban.leads.high'),
          time: t('kanban.leads.today'),
          phone: '71999990007'
        },
        {
          name: 'Marina Rossi',
          status: t('kanban.leads.leadResolved'),
          value: 'R$ 990',
          conversations: 5,
          broadcasts: 5,
          remarketing: 1,
          automations: 4,
          temperature: t('kanban.leads.warm'),
          priority: t('kanban.leads.medium'),
          time: t('kanban.leads.today'),
          phone: '11999990008'
        },
        {
          name: 'Victor Santos',
          status: t('kanban.leads.leadResolved'),
          value: 'R$ 3.490',
          conversations: 2,
          broadcasts: 1,
          remarketing: 0,
          automations: 1,
          temperature: t('kanban.leads.hot'),
          priority: t('kanban.leads.high'),
          time: t('kanban.leads.today'),
          phone: '21999990009'
        }
      ]
    }
  ];

  const colorClasses = {
    purple: 'bg-purple-500/20 border-purple-500/50 text-purple-400',
    green: 'bg-green-500/20 border-green-500/50 text-green-400',
    blue: 'bg-blue-500/20 border-blue-500/50 text-blue-400',
    yellow: 'bg-yellow-500/20 border-yellow-500/50 text-yellow-400',
    orange: 'bg-orange-500/20 border-orange-500/50 text-orange-400',
    red: 'bg-red-500/20 border-red-500/50 text-red-400'
  };

  const temperatureColors = {
    [t('kanban.leads.hot')]: 'bg-red-500/20 text-red-400',
    [t('kanban.leads.warm')]: 'bg-orange-500/20 text-orange-400',
    [t('kanban.leads.cold')]: 'bg-blue-500/20 text-blue-400'
  };

  const priorityColors = {
    [t('kanban.leads.high')]: 'bg-red-500/20 text-red-400',
    [t('kanban.leads.medium')]: 'bg-yellow-500/20 text-yellow-400',
    [t('kanban.leads.low')]: 'bg-green-500/20 text-green-400'
  };

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-gray-900 to-[#0a1628] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-1/3 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-1/3 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6">
            <i className="ri-flashlight-fill text-yellow-400"></i>
            <span className="text-blue-300 text-sm font-medium">{t('kanban.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t('kanban.title')}
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            {t('kanban.subtitle')}
          </p>
        </div>

        {/* Metrics Bar */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
          {metrics.map((metric, index) => (
            <div 
              key={index}
              className={`bg-gray-900/80 backdrop-blur-sm border ${colorClasses[metric.color as keyof typeof colorClasses].split(' ')[1]} rounded-xl p-4`}
            >
              <div className="flex items-center gap-2 mb-2">
                <i className={`${metric.icon} ${colorClasses[metric.color as keyof typeof colorClasses].split(' ')[2]}`}></i>
                <span className="text-gray-400 text-sm">{metric.label}</span>
              </div>
              <div className="text-2xl font-bold text-white mb-1">{metric.value}</div>
              <div className="text-xs text-gray-500">{metric.detail}</div>
            </div>
          ))}
        </div>

        {/* Kanban Board */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 overflow-x-auto">
          {columns.map((column, colIndex) => (
            <div 
              key={colIndex}
              className="bg-gray-900/60 backdrop-blur-sm border border-gray-800 rounded-xl overflow-hidden min-w-[280px]"
            >
              {/* Column Header */}
              <div className="p-4 border-b border-gray-800">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <i className={`${column.icon} ${colorClasses[column.color as keyof typeof colorClasses].split(' ')[2]}`}></i>
                    <span className="text-white font-semibold text-sm">{column.title}</span>
                  </div>
                </div>
                
                {column.tags && (
                  <div className="flex flex-wrap gap-2 mb-2">
                    {column.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className="text-xs text-gray-400 bg-gray-800 px-2 py-1 rounded">
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
                
                {column.stats.leads && (
                  <div className="flex items-center gap-4 text-sm">
                    <span className="text-blue-400">{column.stats.leads}</span>
                    <span className="text-green-400">$ {column.stats.value}</span>
                  </div>
                )}
              </div>

              {/* Lead Cards */}
              <div className="p-3 space-y-3 max-h-[500px] overflow-y-auto">
                {column.leads.map((lead, leadIndex) => (
                  <div 
                    key={leadIndex}
                    className="bg-gray-950/80 border border-gray-800 rounded-lg p-3 hover:border-gray-700 transition-colors cursor-pointer"
                  >
                    <div className="flex items-start justify-between mb-2">
                      <div>
                        <div className="text-white font-medium text-sm">{lead.name}</div>
                        <div className="text-gray-500 text-xs">{lead.status}</div>
                      </div>
                      {lead.score && (
                        <span className="text-xs bg-gray-800 px-2 py-1 rounded text-gray-300">
                          {lead.score}
                        </span>
                      )}
                    </div>

                    {lead.progress !== undefined && (
                      <div className="mb-2">
                        <div className="w-full bg-gray-800 rounded-full h-1.5">
                          <div 
                            className={`h-1.5 rounded-full ${
                              lead.progress >= 70 ? 'bg-blue-500' : 
                              lead.progress >= 40 ? 'bg-purple-500' : 'bg-blue-400'
                            }`}
                            style={{ width: `${lead.progress}%` }}
                          ></div>
                        </div>
                        {lead.monitoring && (
                          <div className="flex items-center justify-between mt-2">
                            <span className="text-xs text-gray-500">{t('kanban.leads.aiMonitoring')}</span>
                            <div className="w-5 h-5 flex items-center justify-center bg-green-500 rounded-full">
                              <i className="ri-check-line text-white text-xs"></i>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {lead.value && (
                      <>
                        <div className="text-green-400 font-semibold text-sm mb-2">$ {lead.value}</div>
                        
                        <div className="grid grid-cols-2 gap-2 text-xs text-gray-500 mb-3">
                          <div className="flex items-center gap-1">
                            <i className="ri-chat-1-line"></i>
                            <span>{lead.conversations} {t('kanban.leads.conversations')}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <i className="ri-send-plane-fill"></i>
                            <span>{lead.broadcasts} {t('kanban.leads.broadcasts')}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <i className="ri-refresh-line"></i>
                            <span>{lead.remarketing} {t('kanban.leads.remarketing')}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <i className="ri-flashlight-line"></i>
                            <span>{lead.automations} {t('kanban.leads.automations')}</span>
                          </div>
                        </div>

                        <div className="flex flex-wrap gap-1 mb-2">
                          <span className={`text-xs px-2 py-0.5 rounded ${temperatureColors[lead.temperature as keyof typeof temperatureColors]}`}>
                            {lead.temperature}
                          </span>
                          <span className={`text-xs px-2 py-0.5 rounded ${priorityColors[lead.priority as keyof typeof priorityColors]}`}>
                            ⭐ {lead.priority}
                          </span>
                          <span className="text-xs px-2 py-0.5 rounded bg-gray-800 text-gray-400">
                            ⏰ {lead.time}
                          </span>
                        </div>

                        <div className="flex items-center gap-1 text-xs text-gray-500">
                          <i className="ri-phone-line"></i>
                          <span>{lead.phone}</span>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>

              {/* Column Footer */}
              {column.stats.leads && (
                <div className="p-3 border-t border-gray-800 text-xs text-gray-500 flex justify-between">
                  <span>{t('kanban.leads.total')}: {column.stats.value}</span>
                  <span>{t('kanban.leads.average')}: R$ {(parseInt(column.stats.value.replace(/\D/g, '')) / parseInt(column.stats.leads)).toFixed(0)}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
